import { useEffect } from "react";

const ApiDocsRedirect = () => {
  useEffect(() => {
    const base = String(process.env.REACT_APP_SERVER_URL || "").replace(
      /\/$/,
      ""
    );
    window.location.replace(`${base}/docs/`);
  }, []);
  return null;
};

export default ApiDocsRedirect;
